Bingo.ListItemHider = {};

Bingo.ListItemHider.init = function () {
    $('body').on('click', '.js-listItemTrigger', function () {
        const selector = $(this).attr('data-target');
        $(selector).removeClass('d-none');
        $(this).remove();
        return false;
    });
};
